import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'appointment-consent');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'survey_assignments',
    {
      type: 'payload',
      selector: ['assignmentId'],
    },
    'appointment_consent.json',
    {
      type: 'payload.query',
      queryParameter: 'appointment_consent_id',
      selector: ['appointmentConsentId'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/appointment-consent-req.js